class Point {
  x: number;
  y: number;
  leftControl: Point | null;
  rightControl: Point | null;

  constructor(x: number = 0, y: number = 0) {
    this.x = x;
    this.y = y;
  }

  distanceFrom(p2: Point): number {
    var a = this.x - p2.x;
    var b = this.y - p2.y;

    return Math.sqrt(a * a + b * b);
  }
}

export default Point;



// WEBPACK FOOTER //
// ./src/data/Point.ts